var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { useCallback, useContext, useEffect } from "react";
import { actionsContext, globalGettersContext, globalStoreContext, mutationsContext } from "./storeContext";
import { filterObjectModuleKeys } from "./helpers";
import { useStore } from './externalStore';
export var useAction = function (actionName) {
    var globalStore = useContext(globalStoreContext);
    var actions = useContext(actionsContext);
    var mutations = useContext(mutationsContext);
    var action = actions[actionName];
    if (!action) {
        throw new Error("Cannot find action: " + actionName);
    }
    var actionWithStoreParams = useCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!globalStore)
            throw new Error('No store found');
        var moduleNames = actionName.split('/');
        var filteredActions = actions;
        var filteredMutations = mutations;
        if (moduleNames.length > 1) {
            filteredActions = filterObjectModuleKeys(actions, actionName);
            filteredMutations = filterObjectModuleKeys(mutations, actionName);
        }
        return action.apply(void 0, __spreadArray([{ actions: filteredActions, mutations: filteredMutations, state: globalStore.getState() }], args));
    }, [actions, mutations, actionName]);
    return actionWithStoreParams;
};
export var useActions = function (values) {
    var actions = useContext(actionsContext);
    var result = [];
    values.forEach(function (actionName) {
        if (!actions[actionName]) {
            throw new Error("Cannot find action: " + actionName);
        }
        else {
            result.push(actions[actionName]);
        }
    });
    return result;
};
export var useMutation = function (mutationName) {
    var mutations = useContext(mutationsContext);
    if (!mutations[mutationName]) {
        throw new Error("Cannot find mutation: " + mutationName);
    }
    return mutations[mutationName];
};
export var useMutations = function (values) {
    var mutations = useContext(mutationsContext);
    var result = [];
    values.forEach(function (mutationName) {
        if (!mutations[mutationName]) {
            throw new Error("Cannot find mutation: " + mutationName);
        }
        else {
            result.push(mutations[mutationName]);
        }
    });
    return result;
};
export var useGetter = function (getterName) {
    var gettersStore = useContext(globalGettersContext);
    var value = useStore(gettersStore.current, getterName);
    return value;
};
export var useActionOnMount = function (actionName) {
    var params = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        params[_i - 1] = arguments[_i];
    }
    var action = useAction(actionName);
    useEffect(function () {
        action.apply(void 0, params);
    }, __spreadArray([action], params));
};
